module.exports = __webpack_public_path__ + "img/add-to-talentpool-white.32aa676a.svg";